import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import RegulationContent from './components/RegulationContent';

export default function RegulationPage() {
  const siteUrl = (window as any).__VITE_SITE_URL__ || 'https://kangyong.com';
  useSEO({
    title: '法規風險｜保健食品法規合規・標示審查・認證申請｜康永生技',
    description: '康永生技法規風險管理：協助品牌進行法規合規審查、產品標示審查、健康食品認證申請、外銷法規諮詢，從源頭杜絕法規風險。',
    keywords: '法規風險,保健食品法規,食品標示,健康食品認證,TFDA,外銷法規',
    lang: 'zh-TW',
    canonicalPath: '/about/regulation',
  });

  return (
    <Layout>
      <SEOJsonLd type="WebPage" pageTitle="法規風險｜保健食品法規合規・標示審查・認證申請｜康永生技" pageDescription="康永生技法規風險管理：協助品牌進行法規合規審查、產品標示審查、健康食品認證申請、外銷法規諮詢，從源頭杜絕法規風險。" pageUrl={`${siteUrl}/about/regulation`} />
      <RegulationContent />
    </Layout>
  );
}